module.exports = __webpack_public_path__ + "img/baoxiang.e9747f85.png";